export default __webpack_public_path__ + "static/media/verloren.526bb574.svg";